import React from 'react';
import { IProps, IState } from './types';
import SliderMobile from 'components/SliderMobile';
import ProgramBlock from 'components/ProgramBlock';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import _ from 'lodash';
import { Inscat } from 'bff/models/info';
import { InsType } from 'constants/enums/insType.enum';
import { Favorite } from 'bff/models/member';
import { Dispatch } from 'redux';
import { removeFavoriteItem } from 'redux/actions/components/myFavorite.action';
import { RecommandCount } from 'constants/enums/showCount.enum';
import service from 'bff/services/favoriteListService';
// import commonService from 'utils/commonService';
// import moment from 'moment';

class FavoriteList extends React.Component<IProps, IState> {
  state: IState = {
    inscats: new Array(0),
    activeTab: InsType.All,
    showCount: RecommandCount.All
  }

  componentDidMount = async () => {
    const inscats = await service.fetchInscats();
    if (!inscats) return;

    this.setState({
      inscats: [...inscats]
    });
  }

  componentDidUpdate () {
    // console.log('componentDidUpdate');
  }

  /**
   * @description Tab 切換事件
   * @param insType 要切換的險種 type
   */
  handleActiveTabChange = (insType: string) => {
    if (this.state.activeTab === insType) return;

    this.setState({
      activeTab: insType
    });
  }

  /**
   * @description 取得要顯示的推薦方案資料
   * @param tab 當前使用的 tab
   */
  handleGetFavoriteList = (tab: string) => {
    if (tab === InsType.All) return [...this.props.myFavoriteList];

    return _.filter(this.props.myFavoriteList, (favorite: Favorite) => favorite.INS_TYPE_ID === tab);
  }

  render () {
    // #region 產生 Tab 項目
    const favoriteListTab: JSX.Element[] = [];
    const favoriteListTabMobile: JSX.Element[] = [];
    const favoriteListTabMobileSlider: JSX.Element[] = [];

    if (this.state.inscats.length > 0) {
      const allClassName = this.state.activeTab === InsType.All
        ? 'favorite-list__tab favorite-list__tab--active'
        : 'favorite-list__tab';

      let childElement = (
        <div key={InsType.All} className={allClassName} onClick={() => this.handleActiveTabChange(InsType.All)}>
          <span>全部</span>
        </div>
      );

      favoriteListTab.push(childElement);
      favoriteListTabMobile.push(
        <SliderMobile.Item key={InsType.All}>
          {childElement}
        </SliderMobile.Item>
      );

      _.map(this.state.inscats, (inscat: Inscat, index: number) => {
        const className = this.state.activeTab === inscat.INS_TYPE_ID
          ? 'favorite-list__tab favorite-list__tab--active'
          : 'favorite-list__tab';
        childElement = (
          <div key={index} className={className} onClick={() => this.handleActiveTabChange(inscat.INS_TYPE_ID)}>
            <span>{inscat.INS_TYPE_NAME}</span>
          </div>
        );

        favoriteListTab.push(childElement);
        favoriteListTabMobile.push(
          <SliderMobile.Item key={index}>
            {childElement}
          </SliderMobile.Item>
        );
      });

      favoriteListTabMobileSlider.push(
        <SliderMobile
          key={0}
          name="favorite-list-mobile-tabs-slider"
          config={{
            breakpoints: {
              375: {
                slidesPerView: 3
              },
              0: {
                slidesPerView: 2
              }
            }
          }}
        >
          {favoriteListTabMobile}
        </SliderMobile>
      );
    }

    // #endregion

    // #region 建立我的收藏卡片

    const programBlocks: any[] = [];
    if (this.props.myFavoriteList?.length > 0) {
      const favorites = this.handleGetFavoriteList(this.state.activeTab);
      // console.log('favoritesList favorites', favorites);
      _.forEach(favorites, (favorite:Favorite, index:number) => {
        if (this.state.showCount && programBlocks.length >= this.state.showCount) return;
        if (!favorite.CONTENT) return;

        programBlocks.push(
          <ProgramBlock
            key={`${index}`}
            active
            insTypeId={favorite.INS_TYPE_ID}
            content={favorite}
            onRemoveItem={() => this.props.onRemoveFavoriteItem(favorite.SN)}
          />);
      });

      if (programBlocks.length === 0) programBlocks.push(<p key={0}>無任何收藏方案</p>);
    } else {
      programBlocks.push(<p key={0}>無任何收藏方案</p>);
    }

    // #endregion

    return (
      <div className="favorite-list">
        <div className="template-container">
          <div className="favorite-list__content">
            <div className="favorite-list__title">收藏清單</div>
            <div className="favorite-list__tabs">
              {favoriteListTab}
            </div>
            <div className="favorite-list-mobile__tabs">
              {favoriteListTabMobileSlider}
            </div>
            <div className="favorite-list__programs">
              {programBlocks}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    myFavoriteList: state.myFavorite.myFavoriteList
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onRemoveFavoriteItem: (sn: number) => dispatch(removeFavoriteItem(sn))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteList);
